export const PRODUCT_STATUS_DRAFT = "DRAFT";
export const PRODUCT_STATUS_READY = "READY";
export const PRODUCT_STATUS_DISMISSED = "DISMISSED";
export const PRODUCT_STATUS_D = "D";
export const PRODUCT_STATUS_R = "R";
export const PRODUCT_STATUS_X = "X";
export const PROMO_STATUS_ACTIVE = "ACTIVE";
export const PROMO_STATUS_DISABLED = "DISABLED";
export const PROMO_STATUS_DRAFT = "DRAFT";
export const PROMO_VISIBILITY_PUBLIC = "PUBLIC";
export const PROMO_VISIBILITY_PRIVATE = "PRIVATE";
export const PROMO_TYPOLOGY_SHORT_TERM = "SHORT_TERM";
export const PROMO_TYPOLOGY_SUBSCRIPTION = "SUBSCRIPTION";
export const PROMO_TYPOLOGY_CREDIT_CARD = "CREDIT_CARD"
export const COUPON_CAMPAIGN_STATUS_ACTIVE = "ACTIVE";
export const COUPON_CAMPAIGN_STATUS_DISMISSED = "DISMISSED";
export const COUPON_CAMPAIGN_STATUS_DRAFT = "DRAFT";
export const COUPON_CODE_STATUS_USED = "USED";
export const COUPON_CODE_STATUS_DELIVERED = "DELIVERED";
export const COUPON_CODE_STATUS_NOT_USED = "NOT_USED";
export const BUSINESS_AGREEMENT_STATUS_READY = "READY";
export const BUSINESS_AGREEMENT_STATUS_DISMISSED = "DISMISSED";
export const BUSINESS_AGREEMENT_STATUS_DRAFT = "DRAFT";
export const LEISURE_AGREEMENT_STATUS_READY = "READY";
export const LEISURE_AGREEMENT_STATUS_DISMISSED = "DISMISSED";
export const LEISURE_AGREEMENT_STATUS_DRAFT = "DRAFT";
export const AFFILIATE_STATUS_DISMISSED = "DISMISSED";
export const AFFILIATE_STATUS_READY = "READY";
export const PROCURER_STATUS_READY = "READY";
export const PROCURER_STATUS_DISMISSED = "DISMISSED";
export const DOSSIER_MANDATORY = "MANDATORY";
export const DOSSIER_NOT_MANDATORY = "NOT_MANDATORY";
export const POI_STATUS_READY = "READY";
export const POI_STATUS_DISMISSED = "DISMISSED";
export const POI_STATUS_DRAFT = "DRAFT";
export const POI_SERVICE_SHARE = "SHARE";
export const POI_SERVICE_RENT = "RENT";
export const POI_SERVICE_SUBSCRIBE = "SUBSCRIBE";
export const POI_SERVICE_LEASE = "LEASE";
export const POI_TYPE_EPLUS = "EPLUS";
export const POI_TYPE_DMS = "DMS";
export const POI_TYPE_ASSISTANCE = "ASSISTANCE";
export const POI_TYPE_TEMPLATE_EPLUS = "EPLUS";
export const POI_TYPE_TEMPLATE_DMS = "DMS";
export const POI_TYPE_TEMPLATE_ASSISTANCE = "ASSISTANCE";
export const POI_CHARGING_STATION_TYPE_A = "VELOCE / 2 PRESE";
export const POI_CHARGING_STATION_TYPE_B = "NORMALE / 10 PRESE";
export const POI_ASSISTANCE_TYPE_DETAIL_MECHANICS = "MECHANICS";
export const POI_ASSISTANCE_TYPE_DETAIL_BODYWORK = "BODYWORK";
export const POI_ASSISTANCE_TYPE_DETAIL_GLASS = "GLASS";
export const POI_ASSISTANCE_TYPE_DETAIL_TYRES = "TYRES";
export const POI_ASSISTANCE_TYPE_DETAIL_DELIVERYCENTRE = "DELIVERY_CENTRE";
export const POI_ASSISTANCE_TYPE_BRAND_A = "BMW";
export const POI_ASSISTANCE_TYPE_BRAND_B = "AUDI";
export const VOUCHER_STATUS_USED="USED";
export const VOUCHER_STATUS_EXPIRED="EXPIRED";
export const VOUCHER_STATUS_AVAILABLE="AVAILABLE";
export const VOUCHER_STATUS_REFUNDED="REFUNDED";
export const VOUCHER_STATUS_ONHOLD = "ON_HOLD";
export const VOUCHER_PROVIDER_AMAZON="AMAZON";
export const VOUCHER_PROVIDER_PLATFORM="PLATFORM";
export const VOUCHER_PROVIDER_MOBILITY="MOBILITY"
export const VOUCHER_PROVIDER_FREE="FREE"
export const CONTRACT_STATUS_ONHOLD="ONHOLD";
export const CONTRACT_STATUS_DRAFT="DRAFT";
export const CONTRACT_STATUS_INPROGRESS="INPROGRESS";
export const CONTRACT_STATUS_CANCELLED="CANCELED";
export const CONTRACT_STATUS_CONCLUDED="CONCLUDED";
export const CONTRACT_STATUS_SUSPENDED="SUSPENDED";
export const CONTRACT_PAYMENTS_HISTORY_STATUS_FAILED="FAILED";
export const CONTRACT_PAYMENTS_HISTORY_STATUS_OK="OK";
export const VOUCHER_CUSTOMER_ASSOCIATED="0"
export const VOUCHER_CUSTOMER_NOT_ASSOCIATED="1"
export const VOUCHER_CUSTOMER_IS_AMAZON_BUSINESS="1";
export const VOUCHER_CUSTOMER_IS_NOT_AMAZON_BUSINESS="0";
export const TOBE_SENT="TOBE_SENT";
export const CUSTOMERBASE_KO="CUSTOMERBASE_KO";
export const INVOICING_REQUESTED="INVOICING_REQUESTED";
export const INVOICING_OK="INVOICING_OK";
export const INVOICING_REQUESTED_DO_NOT_SEND="INVOICING_REQUESTED_DO_NOT_SEND";
export const CAR_CLOUD_CATEGORY = "CarCloud";
export const BE_FREE_EVO_CATEGORY = "BE FREE EVO";
export const FLEX_RENT_CATEGORY = "Flex Rent";

export const DECIMAL_5_DIGITS_REG_EXP =  /^\s*-?[0-9]\d*(\.\d{0,5})?\s*$/
export const DECIMAL_REG_EXP =  /^\d*\.?\d*$/
export const SIGNED_DECIMAL_REG_EXP = /^-?\d*\.?\d*$/
export const INTEGER_REG_EXP =  /^\d+$/
export const INTEGER_REG_EXP_COMMA =  /^\d+(,\d+)*$/
export const INTEGER_6_DIGIT_REG_EXP =  /^[0-9]{6}$/
export const ALPHANUMERIC_REG_EXP =  /^[a-zA-Z0-9_]*$/
export const MAIL_ADDRESS_REG_EXP =  /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
export const CURRENCY_REG_EXP = /^\s*-?[0-9]\d*([.\,]\d{0,2})?\s*$/